var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internet-connection-alert"},[_c('a-alert',{attrs:{"type":"warning","show-icon":"","closable":"","message":_vm.title,"description":_vm.details},on:{"close":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }